import { debugLog, type InitialState } from '@schibsted-nmp/advertising-shared';
import type { Script } from '@client/core/utils/Script.js';
import { Scripts as AdnamiScripts } from '@client/core/utils/Adnami/Scripts.js';
import { Scripts as CogwheelScripts } from '@client/core/utils/Cogwheel/Scripts.js';
import { Scripts as PulseScripts } from '@client/core/utils/pulse/Scripts.js';
import { Scripts as AdManagerScripts } from '@client/adManager/Scripts.js';

export namespace Scripts {
  export function* get(
    initialState: InitialState
  ): Generator<Script, void, void> {
    const {
      env,
      config: {
        brand,
        adServer: { gam }
      }
    } = initialState;

    if (env === 'local') {
      yield* PulseScripts.get();
    }

    // if (consent === ConsentStatus.Accepted) {
    //   try {
    //     yield* BrandMetricsScripts.get(brand);
    //   } catch {
    //     debugLog('Brand Metrics script not found for brand:', brand);
    //   }
    // }

    yield* CogwheelScripts.get();

    if (gam) {
      yield* AdnamiScripts.get(brand);
    }

    yield* AdManagerScripts.get(initialState, false);
  }

  export function* load(
    initialState: InitialState
  ): Generator<Promise<Event | null>, void, void> {
    for (const script of get(initialState)) {
      yield injectIntoDom(script);
    }
  }

  export async function injectIntoDom({
    name,
    src,
    defer,
    crossOrigin
  }: Script) {
    if (document.getElementById(`advt-script-${name}`)) {
      debugLog(`${name} injected server-side from advertising-podlet`);
      return null;
    }

    const { promise, resolve, reject } = Promise.withResolvers<Event>();
    const script = document.createElement('script');

    Object.assign(script, {
      src,
      type: 'text/javascript',
      async: true,

      ...(defer && { defer }),
      ...(crossOrigin && { crossOrigin }),

      onload(event) {
        debugLog(`${name} loaded from advertising-podlet`, event);
        resolve(event);
      },

      onerror(error) {
        debugLog(`Failed to load ${name} from advertising-podlet`, error);
        reject(error);
      }
    } satisfies Partial<typeof script>);

    document.head.appendChild(script);

    return await promise;
  }
}
